import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import OrderActions from "./OrderActions";
import { styled } from "@mui/material/styles";
import { CentreData } from "types/models/support/SupportApp";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  "&:first-of-type": {
    paddingLeft: 20,
  },
  "&:last-of-type": {
    paddingRight: 20,
  },
}));

interface TableItemProps {
  data: CentreData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {   
const getStatusColor = () => {
    switch (data.status) {
      case "Active": {
        return "#43C888";
      }
      case "Inactive": {
        return "#F84E4E";
      }
      default: {
        return "#E2A72E";
      }
    }
  };
  return (
    <TableRow key={data.categoryName} className="item-hover">
      <StyledTableCell align="left">{data.sNo}</StyledTableCell>
      <StyledTableCell component="th" scope="row">
        <Box
          sx={{
            color: "black", 
            borderBottom: "none",
            display: "inline-block",
          }}
        >
          {data.categoryName}
        </Box>
      </StyledTableCell>
    
      <StyledTableCell align="left">{data.parentCategory}</StyledTableCell>
      <StyledTableCell align="left">{data.type}</StyledTableCell>
      <StyledTableCell align="left">
        <Box
          sx={{
            color: getStatusColor(),
            backgroundColor: getStatusColor() + "44",
            padding: "3px 5px",
            borderRadius: 1,
            fontSize: 14,
            display: "inline-block",
          }}
        >
          {data.status}
        </Box>
      </StyledTableCell>
      
      <StyledTableCell align="right">
        <OrderActions data={data}   />
      </StyledTableCell>
    </TableRow>
  );
};

export default TableItem;
